import { ElementRef, Renderer2, Directive } from '@angular/core';
import { AbstractControl, NgForm, ValidationErrors, Validator } from '@angular/forms';

import { BrowserService } from 'webcommon/legacy-common';
import { ApTemplateFormValidatorBase } from './ap-template-form-validator-base';

@Directive()
export abstract class ApRequiredBase extends ApTemplateFormValidatorBase implements Validator {

  constructor(
    browserService: BrowserService,
    elementRef: ElementRef,
    ngForm: NgForm,
    renderer: Renderer2,
  ) {
    super(browserService, elementRef, ngForm, renderer);
  }

  override validate(control: AbstractControl): ValidationErrors | null {
    let result = super.validate(control);

    if (!this.getIsValid()) {
      if (!result) {
        result = {};
      }

      let helperText = 'Required field';
      if (this.label?.textContent) {
        helperText = `${this.label.textContent} is a required field`;
      }
      result.apRequired = helperText;
    }

    return result;
  }

  protected abstract getIsRequired(): boolean;
  protected abstract isShowRequiredOnly(): boolean;

  protected hasValue(): boolean {
    return this.control.value ||
      this.control.value === 0;
  }

  protected override getErrorPropertyName(): string {
    return 'apRequired';
  }

  private getIsValid() {
    const isValid = !this.getIsRequired() || this.hasValue() || this.isShowRequiredOnly();
    return isValid;
  }

  protected override updateCustomClasses() {
    if (this.formGroupInputElement) {
      const formGroupLabelClass = 'ap-form-group-required-new';
      if (this.getIsRequired()) {
        this.renderer.addClass(this.formGroupInputElement, formGroupLabelClass);
      } else {
        this.renderer.removeClass(this.formGroupInputElement, formGroupLabelClass);
      }
    }
  }
}
